/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IDlvryCart containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const enum preferredViewMode {
    listView = 'listView',
    compactView = 'compactView'
}

export interface IDlvryCartConfig extends Msdyn365.IModuleConfig {
    showOutOfStockErrors?: boolean;
    disableInventoryCheckForCompany?: string;
    enableTaxCalculation?: boolean;
    showShippingChargesForLineItems?: boolean;
    imageSettings?: Msdyn365.IImageSettings;
    showAvailablePromotions?: boolean;
    clientRender?: boolean;
    showGuestCheckoutButton?: boolean;
    displayPromoCodeBlock?: boolean;
    preferredViewMode?: preferredViewMode;
    enableCartExportImport?: boolean;
    exportCartLink?: IExportCartLinkData;
    importModalHeading?: IImportModalHeadingData;
    importModalDescription?: Msdyn365.RichText;
    importModalPricesPer?: number;
}

export interface IDlvryCartResources {
    pickUpAtStoreWithLocationText: string;
    bopisSelectAStore: string;
    orLabel: string;
    backToShopping: string;
    outOfStockErrorMessageHeader: string;
    outOfStockErrorMessage: string;
    errorMessageOutOfRangeOneLeft: string;
    errorMessageOutOfRangeFormat: string;
    cartTitle: string;
    emptyCartText: string;
    failToGetCartText: string;
    removeCartButtonText: string;
    cartRemoveButtonAriaLabel: string;
    pickUpAtStoreText: string;
    pickUpText: string;
    shippingText: string;
    emailshippingText: string;
    waitingClass: string;
    decrementButtonAriaLabel: string;
    incrementButtonAriaLabel: string;
    inputQuantityAriaLabel: string;
    discountStringText: string;
    saveForLaterText: string;
    nameOfWishlist: string;
    productDimensionTypeColor: string;
    productDimensionTypeSize: string;
    productDimensionTypeStyle: string;
    productDimensionTypeAmount: string;
    productDimensionTypeConfiguration: string;
    shipInsteadDisplayText: string;
    changeStoreDisplayText: string;
    quantityDisplayText: string;
    shipToAddressDisplayText: string;
    pickItUpDisplayText: string;
    payInvoicesDisplayText: string;
    totalSavingsText: string;
    originalPriceText: string;
    currentPriceText: string;
    cartLoadingErrorMessage: string;
    orderSummaryTitle: string;
    invoiceSummaryTitle: string;
    invoiceLabel: string;
    itemsWithCountLabel: string;
    estimatedShippingLabel: string;
    shippingCharges: string;
    priceFree: string;
    estimatedTaxLabel: string;
    totalAmountLabel: string;
    totalSavings: string;
    conditionsText: string;
    yetToBeCalculatedText: string;
    orderTotal: string;
    otherCharges: string;
    notApplicationForCartOrderSummary: string;
    totalDiscountsLabel: string;
    guestCheckoutButtonTitle: string;
    checkoutButtonTitle: string;
    backToShoppingButtonTitle: string;
    addToWishlistButtonText: string;
    removeFromWishlistButtonText: string;
    defaultWishlistName: string;
    promoCodeHeadingText: string;
    promoPlaceholderText: string;
    promoCodeApplyButtonText: string;
    removePromoAriaLabelFormat: string;
    removePromoText: string;
    appliedPromoCodeHeadingText: string;
    invalidPromoCodeErrorText: string;
    failedToAddPromoCodeErrorText: string;
    failedToRemovePromoCodeErrorText: string;
    duplicatePromotionErrorText: string;
    createOrderTemplateFromCartButton: string;
    createOrderTemplateFromCartButtonTooltip: string;
    addToOrderTemplateButtonTooltip: string;
    createOrderTemplateHeader: string;
    orderTemplateTitle: string;
    orderTemplateNameAriaLabel: string;
    createOrderTemplateDescription: string;
    createNewOrderTemplateButtonText: string;
    createOrderTemplateButtonText: string;
    cancelNewOrderTemplateCreationButtonText: string;
    defaultOrderTemplateName: string;
    addToOrderTemplateHeader: string;
    noOrderTemplatesMessage: string;
    noOrderTemplatesDescription: string;
    createAnOrderTemplateButtonText: string;
    cancelOrderTemplateCreationButtonText: string;
    selectTemplatesText: string;
    addToTemplateButtonText: string;
    lineItemsText: string;
    addToOrderTemplateButtonText: string;
    addToOrderTemplateMessage: string;
    addItemToOrderTemplateError: string;
    viewOrderTemplateButtonText: string;
    continueShoppingButtonText: string;
    linesAddedToOrderTemplateHeaderItemsOneText: string;
    linesAddedToOrderTemplateHeaderItemsFormatText: string;
    linesAddedToOrderTemplateHeaderLinesOneText: string;
    linesAddedToOrderTemplateHeaderLinesFormatText: string;
    linesAddedToOrderTemplateHeaderMessageText: string;
    linesAddedToOrderTemplateCustomPriceAlertMessageText: string;
    itemAddedToOrderTemplateHeaderItemOneText: string;
    itemAddedToOrderTemplateHeaderItemFormatText: string;
    itemAddedToOrderTemplateHeaderMessageText: string;
    freePriceText: string;
    duplicatedProductsHeader: string;
    duplicatedProductsDescription: string;
    updateQuantityButtonText: string;
    cancelDuplicateItemsButtonText: string;
    promotionStringHeading: string;
    promotionLinkText: string;
    promotionPopupHeading: string;
    promotionCloseButtonAriaLabel: string;
    itemLabel: string;
    itemsLabel: string;
    titleSeparate: string;
    priceEditorInputAriaLabel: string;
    specifyAmountButtonText: string;
    payFullAmountButtonText: string;
    salesAgreementPricePrompt: string;
    checkoutBlockedDueToUnavailableFundsTitle: string;
    checkoutBlockedDueToUnavailableFundsMessage: string;
    productListOrderQuantityLabel: string;
    productListActionsLabel: string;
    productListItemText: string;
    productListItemNumberText: string;
    productListItemNameText: string;
    productListUnitNameText: string;
    discount: string;
    lineAmount: string;
    productListPriceText: string;
    buyNowButtonText: string;
    sortByDropdownLabel: string;
    sortByOldestFirst: string;
    sortByOptionNameAsc: string;
    sortByOptionNameDesc: string;
    sortByOptionPriceAsc: string;
    sortByOptionPriceDesc: string;
    sortByOptionRelevanceDesc: string;
    sortByOptionLineAmountAsc: string;
    sortByOptionLineAmountDesc: string;
    removeSelectedToCartText: string;
    emptyCartButtonText: string;
    productListTotalPriceText: string;
    searchPlaceholderText: string;
    exportCartButtonText: string;
    importCartButtonText: string;
    importInputPlaceholderText: string;
    importInvalidNumberOfValuesError: string;
    importInvalidQuantityForSKUError: string;
    importInvalidAnbrekkError: string;
    importInvalidProductsError: string;
    importInvalidLinesWarningMessage: string;
    importInvalidLinesWarningMessagePlural: string;
    importProductNumberHeader: string;
    importNameHeader: string;
    importQuantityHeader: string;
    importAnbrekkHeader: string;
    importPriceHeader: string;
    importTotalHeader: string;
    importErrorHeader: string;
    importProgressRetrievingProducts: string;
    importProgressRetrievingPrices: string;
    importProgressRetrievingPricesSection: string;
    importProgressAddingToCartText: string;
    importAddToCartSuccessText: string;
    importValidateButtonText: string;
    importRevalidateButtonText: string;
    importImportButtonText: string;
    importCancelButton: string;
    importCloseButton: string;
    importUnsortedErrorsDescriptionText: string;
    importUnsortedErrorsErrorHeaderText: string;
    importUnsortedErrorsQuantityHeaderText: string;
    yes: string;
    no: string;
    availabilityError: string;
    transitTooltip: string;
    agreementProductTooltip: string;
    recalculatingText: string;
    toastErrorHeader: string;
    specialOrdersWarning: string;
    viewModeCardText: string;
    viewModeListText: string;
    viewModeCompact: string;
    deleteLinesConfirmationTitle: string;
    deleteLinesConfirmationMessage: string;
    emptyCartConfirmationTitle: string;
    emptyCartConfirmationMessage: string;
    priceNotLoggedInText: string;
    depositSuffixText: string;
    removedOutOfSeasonProductsTitle: string;
    removedOutOfSeasonProductsPluralTitle: string;
    hideRemovedOutOfSeasonProductsButtonLabel: string;
}

export interface IExportCartLinkData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export const enum ImportModalHeadingTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IImportModalHeadingData {
    text: string;
    tag?: ImportModalHeadingTag;
}

export interface IDlvryCartProps<T> extends Msdyn365.IModule<T> {
    resources: IDlvryCartResources;
    config: IDlvryCartConfig;
    slots: {
        storeSelector: React.ReactNode[];
        paymentExpress: React.ReactNode[];
        emptyCart: React.ReactNode[];
    };
}
